import { getLogger } from '../dataDog'

export const logMessageError = (errorMessage, apiError) => {
  getLogger().error(`${errorMessage} - ${apiError}`)
}
